import { clientApi } from 'api';
import { IExhibitedProduct } from 'server/models/ExhibitedProduct/types';
export const getOneExhibitedProduct = (isServer = false) => async (id: string) => {
  const response = await clientApi.get<IExhibitedProduct>(`/exhibited-products/${id}`);

  return response;
};
